new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            const isPartiallyVisible =
                rect.bottom > 0 &&
                rect.top < window.innerHeight;

            const otherElement = document.querySelector(".product-detail__fixed--buy");

            if (otherElement) {
                otherElement.classList.toggle("active", !isPartiallyVisible);
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
       
        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = Array.from(
                description.querySelectorAll('.nav-item')
            );

            navTab[0].classList.add('active')

            let navShow = Array.from(
                description.querySelectorAll('.description-nav-content')
            );

            navShow[0].classList.add('active')

            // calcula altura apenas uma vez ao carregar
            navShow.forEach((content) => {
                content.style.height = `${content.scrollHeight + 20}px`;
            });

            if (navTab.length && navShow.length) {

                function activeTab(index) {

                    const isActive =
                        navTab[index].classList.contains('active');

                    // remove active de todos
                    navTab.forEach((tab) => {
                        tab.classList.remove('active');
                    });

                    navShow.forEach((content) => {
                        content.classList.remove('active');
                    });

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        activeTab(index);
                    });
                });
            }
        }
        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isAllowSelectProducts = () => {
            const buyTogetherApi = document.querySelector('.buy-together-api');
            return buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products');
        };

        // Verifica se o grupo realmente precisa de seleção
        const groupRequiresSelection = (group) => {
            if (!group) return false;
            return !!group.querySelector('.product-item__options');
        };

        const getGroupsToCheck = () => {
            let allGroups = getGroups();

            // Remove grupos que não possuem opções e portanto não precisam ser selecionados
            allGroups = allGroups.filter(groupRequiresSelection);

            // Se tiver .allow-select-products, filtra apenas grupos com checkbox marcado
            if (isAllowSelectProducts()) {
                return allGroups.filter(group => {
                    const checkbox = group.querySelector('.checkbox-together-selectable');
                    return checkbox && checkbox.checked;
                });
            }

            return allGroups;
        };

        const isGroupSelected = (group) => {
            if (!group) return false;

            const options = group.querySelector('.product-item__options');

            // Se não existe opções, considera como "não precisa selecionar"
            if (!options) return true;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via radio
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            // Seleção via checkbox
            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback)
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i =>
                    (i.type !== 'radio' && i.type !== 'checkbox') &&
                    i.value &&
                    String(i.value).trim() !== ''
                );
            }

            // Se existe .product-item__options mas não encontrou campos selecionáveis,
            // considera como não obrigatório para não travar a compra
            return true;
        };

        const updateUI = () => {
            const allGroups = getGroups();
            const groupsToCheck = getGroupsToCheck();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);

            if (!allGroups.length || !addCartBtn) return;

            // Atualiza classe please-select apenas em grupos que realmente exigem seleção
            allGroups.forEach(group => {
                const requiresSelection = groupRequiresSelection(group);
                const selected = isGroupSelected(group);

                group.classList.toggle('please-select', requiresSelection && !selected);
            });

            // Libera compra quando todos os grupos que exigem seleção estiverem selecionados
            // Se não houver nenhum grupo exigindo seleção, libera normalmente
            const allSelected = groupsToCheck.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            const buyTogetherApi = document.querySelector('.buy-together-api');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;

                if (
                    target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable')
                ) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;

                if (
                    target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable') ||
                    target.closest('.checkbox-together-selectable')
                ) {
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            if (buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products')) {
                const handleCheckboxChange = (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable'))
                    ) {
                        updateUI();
                    }
                };

                const handleCheckboxClick = (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable'))
                    ) {
                        setTimeout(updateUI, 10);
                    }
                };

                buyTogetherApi.addEventListener('change', handleCheckboxChange, { passive: true });
                buyTogetherApi.addEventListener('click', handleCheckboxClick, { passive: true });

                document.addEventListener('change', (e) => {
                    const target = e.target;
                    if (
                        target &&
                        target.classList.contains('checkbox-together-selectable') &&
                        buyTogetherApi.contains(target)
                    ) {
                        updateUI();
                    }
                }, { passive: true });

                document.addEventListener('click', (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable')) &&
                        buyTogetherApi.contains(target.closest('.checkbox-together-selectable') || target)
                    ) {
                        setTimeout(updateUI, 10);
                    }
                }, { passive: true });

                const checkboxObserver = new MutationObserver((mutations) => {
                    let shouldUpdate = false;

                    mutations.forEach((mutation) => {
                        if (
                            mutation.type === 'attributes' &&
                            (mutation.attributeName === 'checked' || mutation.attributeName === 'class')
                        ) {
                            shouldUpdate = true;
                        }
                    });

                    if (shouldUpdate) {
                        updateUI();
                    }
                });

                const observeCheckboxes = () => {
                    const checkboxes = buyTogetherApi.querySelectorAll('.checkbox-together-selectable');
                    checkboxes.forEach(checkbox => {
                        checkboxObserver.observe(checkbox, {
                            attributes: true,
                            attributeFilter: ['checked', 'class']
                        });
                    });
                };

                const checkboxContainerObserver = new MutationObserver((mutations) => {
                    let shouldObserve = false;

                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldObserve = true;
                        }
                    });

                    if (shouldObserve) {
                        observeCheckboxes();
                        setTimeout(updateUI, 10);
                    }
                });

                checkboxContainerObserver.observe(buyTogetherApi, {
                    childList: true,
                    subtree: true,
                    attributes: false
                });

                observeCheckboxes();
            }

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });

            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        updateUI();
    });

    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    if (window.matchMedia("(min-width: 992px)").matches) {
        let lastScrollTop = 0;

        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const banner = document.querySelector('.product-detail__banner');
            const appHeader = document.getElementById('app_header');

            if (photoScroll) {
                const infoArea = document.querySelector('.product-detail__header--infoArea');
                const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                const containerHeight = $container.outerHeight();
                const containerTop = $container.offset() ? $container.offset().top : 0;
                const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
                const containerWidth = $container.width();
                const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
                const pageTop = window.scrollY;

                // Verifica se existe banner e calcula quando ele sai da tela
                let bannerOffset = 0;
                if (banner) {
                    const bannerRect = banner.getBoundingClientRect();
                    const bannerHeight = banner.offsetHeight;
                    bannerOffset = bannerHeight;
                }

                // Calcula a altura do header para o top na volta
                let headerHeight = 0;
                if (appHeader) {
                    headerHeight = appHeader.offsetHeight;
                }

                // Posição atual do bottom do header na viewport (acompanha header dinâmico)
                const scrollingUp = pageTop < lastScrollTop;
                const headerBottom = appHeader
                    ? (scrollingUp ? headerHeight : Math.max(0, appHeader.getBoundingClientRect().bottom))
                    : 0;

                // Limites de scroll baseados no container e header
                const safeTotalHeight = Math.max(0, totalHeight);
                const startScroll = containerTop - headerHeight; // ponto para começar a fixar
                const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

                if (pageTop <= startScroll) {
                    // Antes do container tocar o header: posição normal
                    $('.sidebar__inner').css({ position: 'sticky' });
                    $('.sidebar__inner').css({ top: "0px" });
                    $('.sidebar__inner').css({ width: "100%" });
                    $('.sidebar__inner').css({ maxWidth: "100%" });
                } else if (pageTop >= endScroll) {
                    // Depois do final do container: travado no rodapé do container
                    $('.sidebar__inner').css({ position: 'sticky' });
                    $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
                    $('.sidebar__inner').css({ width: "100%" });
                    $('.sidebar__inner').css({ maxWidth: "100%" });
                } else {
                    // Dentro da faixa: fixo acompanhando o bottom atual do header
                    $('.sidebar__inner').css({ position: 'fixed' });
                    $('.sidebar__inner').css({ top: headerBottom + "px" });
                    if (containerWidth) {
                        $('.sidebar__inner').css({ width: containerWidth + "px" });
                        $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
                    }
                }

                lastScrollTop = pageTop;
            }
        }

        window.addEventListener('scroll', function () {
            if (screen.width > 991) {
                const photoScroll = document.querySelector('.product-detail__header--photoArea');
                if (photoScroll) {
                    animeScroll();
                }
            }
        });

        window.onresize = function () {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            if (photoScroll) {
                if ($('.sidebar__inner').css('position') === 'fixed') {
                    const infoArea = document.querySelector('.product-detail__header--infoArea');
                    const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                    const containerWidth = $container.width();
                    if (containerWidth) {
                        $('.sidebar__inner').css({ width: containerWidth + "px" });
                        $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
                    }
                }
            }
        };
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                    }
                });
            });
        });

        observer.observe(compreJunto, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('.product-rating__review-list')) {
        $('.product-rating__review-list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        appendArrows: $('.product-detail__ratings--content .arrows')
                    }
                },
            ]
        });
    }


    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isAllowSelectProducts = () => {
            const buyTogetherApi = document.querySelector('.buy-together-api');
            return buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products');
        };

        const getGroupsToCheck = () => {
            const allGroups = getGroups();

            // Se tiver .allow-select-products, filtra apenas grupos com checkbox marcado
            if (isAllowSelectProducts()) {
                return allGroups.filter(group => {
                    // Procura checkbox dentro do grupo
                    const checkbox = group.querySelector('.checkbox-together-selectable');
                    return checkbox && checkbox.checked;
                });
            }

            // Caso contrário, retorna todos os grupos
            return allGroups;
        };

        const isGroupSelected = (group) => {
            if (!group) return false;
            const options = group.querySelector('.product-item__options');
            if (!options) return false;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via inputs (ex: radio)
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback): considera preenchido se houver value não vazio
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i => (i.type !== 'radio' && i.type !== 'checkbox') && i.value && String(i.value).trim() !== '');
            }

            return false;
        };

        const updateUI = () => {
            const allGroups = getGroups();
            const groupsToCheck = getGroupsToCheck();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!allGroups.length || !addCartBtn) return;

            // Atualiza classe please-select por grupo (todos os grupos)
            allGroups.forEach(group => {
                const selected = isGroupSelected(group);
                group.classList.toggle('please-select', !selected);
            });

            // Regra: liberar compra quando TODOS os grupos a verificar tiverem seleção
            // Se tiver .allow-select-products, só verifica grupos com checkbox marcado
            // Caso contrário, verifica todos os grupos presentes
            const allSelected = groupsToCheck.length > 0 && groupsToCheck.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            const buyTogetherApi = document.querySelector('.buy-together-api');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica mudanças nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable')) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;
                // Verifica cliques nos grupos ou nos checkboxes de seleção
                if (target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable') ||
                    target.closest('.checkbox-together-selectable')) {
                    // pequeno defer para permitir atualização de checked
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            // Se tiver .allow-select-products, adiciona listeners específicos para os checkboxes
            if (buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products')) {
                // Event listener no buy-together-api para capturar checkboxes que podem estar fora do container
                // Usa delegação de eventos para capturar checkboxes adicionados dinamicamente
                const handleCheckboxChange = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable'))) {
                        updateUI();
                    }
                };

                const handleCheckboxClick = (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable'))) {
                        // pequeno defer para permitir atualização de checked
                        setTimeout(updateUI, 10);
                    }
                };

                buyTogetherApi.addEventListener('change', handleCheckboxChange, { passive: true });
                buyTogetherApi.addEventListener('click', handleCheckboxClick, { passive: true });

                // Também adiciona listener no documento para garantir que capture todas as mudanças
                // mesmo que o checkbox seja adicionado dinamicamente em outro lugar
                document.addEventListener('change', (e) => {
                    const target = e.target;
                    if (target && target.classList.contains('checkbox-together-selectable') &&
                        buyTogetherApi.contains(target)) {
                        updateUI();
                    }
                }, { passive: true });

                document.addEventListener('click', (e) => {
                    const target = e.target;
                    if (target && (target.classList.contains('checkbox-together-selectable') ||
                        target.closest('.checkbox-together-selectable')) &&
                        buyTogetherApi.contains(target.closest('.checkbox-together-selectable') || target)) {
                        setTimeout(updateUI, 10);
                    }
                }, { passive: true });

                // Observa mudanças de atributos (checked) nos checkboxes
                const checkboxObserver = new MutationObserver((mutations) => {
                    let shouldUpdate = false;
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' &&
                            (mutation.attributeName === 'checked' || mutation.attributeName === 'class')) {
                            shouldUpdate = true;
                        }
                    });
                    if (shouldUpdate) {
                        updateUI();
                    }
                });

                // Observa todos os checkboxes existentes e futuros
                const observeCheckboxes = () => {
                    const checkboxes = buyTogetherApi.querySelectorAll('.checkbox-together-selectable');
                    checkboxes.forEach(checkbox => {
                        checkboxObserver.observe(checkbox, {
                            attributes: true,
                            attributeFilter: ['checked', 'class']
                        });
                    });
                };

                // Observa adição de novos checkboxes e mudanças no DOM
                const checkboxContainerObserver = new MutationObserver((mutations) => {
                    let shouldObserve = false;
                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldObserve = true;
                        }
                    });
                    if (shouldObserve) {
                        observeCheckboxes();
                        // Pequeno delay para garantir que o DOM foi atualizado
                        setTimeout(updateUI, 10);
                    }
                });
                checkboxContainerObserver.observe(buyTogetherApi, {
                    childList: true,
                    subtree: true,
                    attributes: false
                });

                // Inicializa observação dos checkboxes existentes
                observeCheckboxes();
            }

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });
            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        // Inicializa estado
        updateUI();
    });



    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                        appendArrows: $('.home-product__list.first-vitrine .arrows'),

                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    const faqItems = document.querySelectorAll('.home__faq--list-item');

    if (faqItems.length > 0) {
        faqItems.forEach(item => {
            item.addEventListener('click', () => {
                item.classList.toggle('active');
            });
        });
    }

})